import { genQueryJsonStr } from '@/utils/querySchema'

export default function () {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const that = this

  const PATH_MAP = {
    customerNum: '/driver/customerManage', // 客户管理
    default: '/workbench/entOrder/list', // 企业租赁
  }
  function goPage(row, key, query = {}) {
    const path = PATH_MAP[key] || PATH_MAP.default
    if (PATH_MAP[key] === PATH_MAP.customerNum) {
      this.$router.push({
        path: PATH_MAP.customerNum,
        query,
      })
    } else {
      this.$router.push(`${path}?query=${genQueryJsonStr(query)}`)
    }
  }
  function renderContent(row, key, query) {
    return this.$createElement('span', {
      class: 'item-active',
      on: {
        click: () => { goPage.call(this, row, key, query) },
      },
    }, row[key])
  }
  const columns = [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    },
    {
      name: 'customerNum',
      columnProps: {
        label: '新增用户数',
        prop: 'customerNum',
      },
      render: ({ row }) => {
        const query = {
          type: 'company',
        }
        return renderContent.call(this, row, 'customerNum', query)
      },
    },
    {
      name: 'mainOrderNum',
      columnProps: {
        label: '新增主订单数',
        prop: 'mainOrderNum',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'mainOrderNum')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subOrderNum',
      columnProps: {
        label: '新增子订单数',
        prop: 'subOrderNum',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
        }
        return renderContent.call(this, row, 'subOrderNum', query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'deliverCarNum',
      columnProps: {
        label: '交车数',
        prop: 'deliverCarNum',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
          search: {
            TheCarExTime: that.dateStr || '',
          },
          children: [{
            tab: '0',

          }],
        }
        return renderContent.call(this, row, 'deliverCarNum', query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'returnCarNum',
      columnProps: {
        label: '退车数',
        prop: 'returnCarNum',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
          search: {
            TheCarinStockTime: that.dateStr || '',
          },
        }
        return renderContent.call(this, row, 'returnCarNum', query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'orderGrowth',
      columnProps: {
        label: '当期净增订单数',
        prop: 'orderGrowth',
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'mainExpiredNum',
      columnProps: {
        label: '当期合同到期数（主订单）',
        prop: 'mainExpiredNum',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'mainExpiredNum')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subExpiredNum',
      columnProps: {
        label: '当期合同到期数（子订单）',
        prop: 'subExpiredNum',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
        }
        return renderContent.call(this, row, 'subExpiredNum', query)
      },
      columnHeaderTooltip: '',
    },
  ]
  return {
    columns,
  }
}

